import { useNavigate } from 'react-router-dom';
import type { NotificationDoc } from './types';
import { notificationIcon } from './notificationIcons';
import { timeAgo } from '../../shared/utils/timeAgo';
import styles from './NotificationPopover.module.css';

export function NotificationPopover({
  items, onMarkRead, onMarkAllRead, onClose,
}: {
  items: NotificationDoc[];
  onMarkRead: (id: string) => void;
  onMarkAllRead: () => void;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const top = items.slice(0, 10);

  function handleClick(n: NotificationDoc) {
    if (!n.read) onMarkRead(n.id);
    onClose();
    if (n.link) navigate(n.link);
  }

  return (
    <div className={styles.popover}>
      <div className={styles.header}>
        <span>Notificações</span>
        <button type="button" className={styles.link} onClick={onMarkAllRead}>Marcar todas como lidas</button>
      </div>
      <ul className={styles.list}>
        {top.length === 0 && <li className={styles.empty}>Nenhuma notificação.</li>}
        {top.map((n) => {
          const Icon = notificationIcon(n.type);
          return (
            <li key={n.id} className={`${styles.item} ${n.read ? '' : styles.unread}`}>
              <button type="button" className={styles.itemBtn} onClick={() => handleClick(n)}>
                <span className={`${styles.icon} ${styles[`p-${n.priority}`]}`}><Icon size={16} /></span>
                <span className={styles.body}>
                  <span className={styles.title}>{n.title}</span>
                  <span className={styles.text}>{n.body}</span>
                </span>
                <span className={styles.time}>{timeAgo(n.createdAt?.toMillis?.())}</span>
              </button>
            </li>
          );
        })}
      </ul>
      <div className={styles.footer}>
        <button type="button" className={styles.link} onClick={() => { onClose(); navigate('/notifications'); }}>
          Ver todas
        </button>
      </div>
    </div>
  );
}
